import React from 'react';
import { LaboratoryRequestItem } from '../../Interfaces/LaboratoryRequestItem.intefrace';
import LaboratoryRequestCreateFormItem from './LaboratoryRequestCreateFormItem';

interface Props {
	items?: LaboratoryRequestItem[];
	onItemSelect: (item: LaboratoryRequestItem) => void;
}

const LaboratoryRequestCreateFormItemChildren: React.FC<Props> = ({
	items,
	onItemSelect,
}) => {
	if ((items?.length || 0) > 0) {
		return (
			<>
				{items?.map((item, key) => (
					<LaboratoryRequestCreateFormItem
						item={item}
						key={key}
						onItemSelect={onItemSelect}
					/>
				))}
			</>
		);
	} else {
		return <></>;
	}
};

export default LaboratoryRequestCreateFormItemChildren;
